<template>
    <div>
        <el-form ref="roleForm" :model="roleForm" :rules="roleFormRules" labelWidth="100px" size="medium">
            <el-form-item label="角色名称：" prop="name">
                <el-input v-model="roleForm.name" placeholder="请输入角色名称" clearable></el-input>
            </el-form-item>
            <el-form-item label="角色代码：" prop="code">
                <el-input  v-model="roleForm.code" placeholder="请输入角色代码" clearable></el-input>
            </el-form-item>
            <el-form-item label="角色描述：" prop="desc">
                <el-input  v-model="roleForm.desc" placeholder="请输入角色描述" clearable></el-input>
            </el-form-item>
            <el-form-item label="是否开启" prop='status'>
                <el-switch
                    v-model="roleForm.status"
                    active-value="active"
                    inactive-value="unactive">
                </el-switch>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    export default {
        name: "roleEdit",
        props:["roleForm"],
        data(){
            return{
                roleFormRules:{
                    name:[
                        {required:true,message:"请输入角色名称",trigger:"blur"}
                    ],
                    code:[
                        {required:true,message:"请输入角色代码",trigger:"blur"}
                    ]
                }
            }
        }
    }
</script>

<style scoped>

</style>